export default __webpack_public_path__ + "static/media/audio.eadc3216.png";